import { remove } from 'lodash';
import { API_URL } from '../../utils/constants';
import request from '../request';

const gombaProdcutsBaseUrl = `${API_URL}/gomba/products`;

export default {
  createGombaProduct: async (genericProductId) => {
    return request(`${gombaProdcutsBaseUrl}/create/by-generic-product/${genericProductId}`, 'post', {}, {});
  },

  updateGombaProduct: async (gombaProductInfoId) => {
    return request(`${gombaProdcutsBaseUrl}/update/by-gomba-product-info/${gombaProductInfoId}`, 'post', {}, {});
  },

  removeGombaProduct: async (gombaProductInfoId) => {
    return request(`${gombaProdcutsBaseUrl}/remove/by-gomba-product-info/${gombaProductInfoId}`, 'post', {}, {});
  },

  removeGombaProductByGombaId: async (gombaId) => {
    return request(`${gombaProdcutsBaseUrl}/remove/by-gomba/${gombaId}`, 'post', {}, {});
  }
};